
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/rooms/[rid]",
      function () {
        return require("private-next-pages/[hid]/rooms/[rid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/rooms/[rid]"])
      });
    }
  